/* 賈詡（字文和） */
import { SG, gd } from '../../core/kit.ts';
import { defineHero, P } from '../define.ts';

export default defineHero({
  id: 'jiaxu', name: '賈詡', sub: '字文和', faction: 'wei', role: '法師', weapon: 'staff',
  look: { head: 'guan', robe: true, eye: 'narrow', beard: 'goatee', hair: '#6a6a6a', fx: '#b6f07a', c: { cloth: '#2f4a3a', sleeve: '#2f4a3a', pole: '#2a2a20' } },
  skills: [
    ['屍操術', 'summon', '喚醒 {1/2/3/4} 具屍兵作戰 40 秒。', { x: { k: 'summon', n: [1, 2, 3, 4], hp: 300, atk: 24, dur: 40, skin: 'zombie', name: '屍兵' }, aim: P(240, 60), el: 'shadow' }],
    ['屍爆', 'fire', '引爆指定地點，對周圍敵人造成 {95/185/275/365} 傷害。', { x: { k: 'aoe', dmg: [95, 185, 275, 365], r: 200, fx: 'fire' }, aim: P(480, 200), cd: [24, 21, 18, 15], el: 'poison' }],
    ['吞食魔法', 'command', '吞掉指定範圍內敵人身上的增益，並解除友軍身上的控制與減益。', { x: { k: 'dispel', r: 220 }, aim: P(480, 220) }],
    ['召喚肉傀儡', 'summon', '召喚肉傀儡作戰 60 秒，生命 {1500/2000/2500}、攻擊 {60/90/120}。', { x: { k: 'summon', hp: [1500, 2000, 2500], atk: [60, 90, 120], dur: 60, size: 32, skin: 'golem', name: '肉傀儡' }, aim: P(240, 40), el: 'shadow' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    dispel(u, a, X) {
      const c = a.pt;
      this.enemiesNear(u, c[0], c[1], X.r).forEach((t) => {
        if (t.structure) return;
        if (t.buffs) { t.buffs = t.buffs.filter((b: any) => b.neg || /^aura:/.test(b.id)); SG._rebuildBuffs(t); }
        t.st.atkUp = t.st.msUp = t.st.shield = t.st.dr = 0;
        if (t.summon && X.dmg) this.damage(u, t, X.dmg, { magic: true });
        if (a.cc) this.applyCC(u, t, a.cc);
      });
      this.units.forEach((t) => { if (t.alive && t.team === u.team && !t.structure && gd(c[0], c[1], t.x, t.y) <= X.r) { const s = t.st; s.stun = s.root = s.slow = s.silence = s.disarm = s.freeze = 0; t.sleeping = false; if (t.buffs) { t.buffs = t.buffs.filter((b: any) => !b.neg); SG._rebuildBuffs(t); } t.dots = null; } });
      this.xFx(u, X, c[0], c[1]);
    },
  },
});
